import CTNEllipsis from '@ctn/ui/components/ctn-ellipsis';
import { CTNIcon, CTNIconTooltip } from '@ctn/ui/components/ctn-icon';
import { type CTNTooltipProps } from '@ctn/ui/types/ctn-tooltip';

import type { Icon } from '@ctn/ui/types/generic';

const FieldIcon = ({
	className,
	icon,
	iconColor,
	title,
	text,
	tooltip,
}: {
	readonly className?: string;
	readonly icon: Icon;
	readonly iconColor?: string;
	readonly title: string;
	readonly text: string;
	readonly tooltip?: CTNTooltipProps;
}) => (
	<div className={`c-ctn-field c-ctn-field--condensed c-ctn-field--no-feedback c-ctn-field--ellipsis ${className ?? ''}`}>
		<label className="c-ctn-field__label">
			<CTNEllipsis className="c-ctn-field__text" content={title} />
			{tooltip && (
				<CTNIconTooltip icon="info" color="blue-50" className="o-media__tooltip" tooltip={tooltip} />
			)}
		</label>
		<span className="o-media">
			<CTNIcon icon={icon} color={iconColor} className="o-media__img" />
			<span className="o-media__text">
				<CTNEllipsis content={text} />
			</span>
		</span>
		
	</div>
);

export default FieldIcon;
